let appName='必背古诗词';
let url, website, wechat, qq, ename, headerBg, tech, merchant_id, custom_id,themeColor,
      custom_type = 'normal';//custom_type 'normal'小程序版，'question' 题库为首页，'both' 首页题库都有
switch (appName) {
      case '必背古诗词':
            // url = 'http://192.168.0.110:3211/app/v2';
            url='http://api.bbgsc.net/app/v2';
            website = 'http://www.bbgsc.net';
            wechat = 'hneway';
            qq = '549942821';
            ename = 'EVCOURSE';
            // themeColor = "#00A3F9";
            themeColor = "#E7CC91";
            tech = "吉林省名扬四海文化传媒有限公司";
            merchant_id = "31667";//"11065";
            custom_id = 39;
            custom_type='normal';
            break;
}

const Config = {
      baseUrl: url,
      port: '80',
      prefix: '/',
      website,
      wechat,
      qq,themeColor,
      ename,
      headerBg,
      tech,
      merchant_id, custom_id, custom_type,appName
}
global.constants=Config
export default Config;